import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  field: {
    position: 'relative',
  },
  menu: {
    maxHeight: 200,
    position: 'absolute',
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.gray200}`,
    borderTop: 0,
    overflow: 'scroll',
    width: '100%',
    zIndex: 1,
  },
}));
